import { Environment } from '@src/config/environment';
import { lazy, Suspense, useEffect } from 'react';
import { useServerStatusStore } from '@src/utils/errorHandling/ServerStatusStore';
import { useTranslation } from 'react-i18next';
import { NetworkError } from '@src/errors/NetworkError';

export const NetworkErrorModal = () => {
  const serverIsDown = useServerStatusStore((s) => s.serverIsDown);
  const setServerIsDown = useServerStatusStore((s) => s.setServerIsDown);
  const { t } = useTranslation('view', { keyPrefix: 'error' });

  useEffect(() => {
    if (!serverIsDown) {
      return;
    }
    const healthCheckUrl = `${Environment.DIRECTUS_API_URL}/server/health`;
    const interval = setInterval(() => {
      console.log('Trying to reconnect');
      void fetch(healthCheckUrl).then((res) => {
        if (res.ok) {
          setServerIsDown(false);
          clearInterval(interval);
        }
      });
    }, Environment.NETWORK_CHECK_INTERVAL);

    return () => clearInterval(interval); // Cleanup on unmount or status change
  }, [serverIsDown, setServerIsDown]);

  if (!serverIsDown) {
    return <></>;
  } else {
    const error = new NetworkError(t('serverUnavailable'));
    return (
      <Suspense>
        <ErrorModal dismissible={false} error={error}></ErrorModal>
      </Suspense>
    );
  }
};

const ErrorModal = lazy(() =>
  import('@components/modals/ErrorModal').then((result) => ({
    default: result.ErrorModal,
  })),
);
